// extracted by mini-css-extract-plugin
export var resizer = "_ez-0";